import appConfig from '../../config';

let nbMount = 0;
const scriptId = 'tb-ext-app';
const scriptProxyUrl = 'https://teambrain.app/antilop/app/teambrain/externalApp/';
const scriptSrc = 'https://teambrain.app/antilop/app/teambrain/externalApp/front/extAccess/dist/tb-external-v1.js?v=1.0&s=bGJ1SWRYcngyNWxUUjNIcUd1T1RTUT09&c=UkhmclNsTEx0NjJaVnZmMElxRzByby9ycVBVQUt4UFo4Q3JBTzlqYzZhbS84Q0NacnY2cU5XL2d0ZGtHYlh2Yw==&app=SW1LaUM1cVk5RWxuZEZ0Q21QRFZ1Zz09&t=Q0hXekxLSmpwZUx2eTlpMjBHbm1VQT09&key=ZzJoOEJNakpKVXJZSUI1MC92ZU51L1lrTnVYdXFlOUxqRGphYys2NGFuSGV1Q1V6SWNlN3VmQUVYSCttUy9sRlhBQ2RiQWJIdXRxMWxKVGYwUFhySjZJc3hvb3EyRXZQY1hFUitNNHlQSDQ9';

function addFAQ() {
  const script = document.createElement('script');
  script.id = scriptId;
  script.setAttribute('data-proxy-url', scriptProxyUrl);
  script.src = scriptSrc;
  script.async = true;
  document.body.appendChild(script);
}

function removeFAQ() {
  const script = document.getElementById(scriptId);
  if (script) {
    script.remove();
  }
  Array.from([
    ...Array.from(document.getElementsByClassName('tb-ae-iconContainer')),
    ...Array.from(document.getElementsByClassName('tb-ae-appContainer')),
    ...Array.from(document.getElementsByClassName('tb-ae-messagesContainer'))
  ]).forEach(el => el.remove());
}

export function mountFAQ() {
  if (!appConfig.featureFlags.showTBFAQ) { return; }
  nbMount += 1;
  if (nbMount === 1) {
    addFAQ();
  }
}

export function unmountFAQ() {
  if (!appConfig.featureFlags.showTBFAQ) { return; }
  nbMount -= 1;
  if (nbMount <= 0) {
    nbMount = 0;
    removeFAQ();
  }
}
